/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  logger.ts
 */

import { createLoggerInterface } from '@zcode/logger'

/* istanbul ignore next */
export const { logger, setLogger, setLogLevel } = createLoggerInterface()
